// extracted by css-extract-rspack-plugin
export default {"pill":"pill-YbvO3c"};